import React, { useState, useId } from 'react';
export default function Accordion({ title, content }) {
  const [isActive, setIsActive] = useState(false);
  const id = useId();
  return <div className="accordion-item">
    <button type="button" className="accordion-title" aria-expanded={isActive} aria-controls={id} onClick={() => setIsActive(!isActive)}><span>{title}</span><span aria-hidden="true">{isActive ? '−' : '+'}</span></button>
    <div id={id} className="accordion-content" hidden={!isActive}>{content}</div>
  </div>;
}
